/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum RESOURCE_ERROR_NAMES {
	RESOURCE_COMPILATION_ERROR = "RESOURCE_COMPILATION_ERROR",
	RESOURCE_INVALID_CONFIG = "RESOURCE_INVALID_CONFIG",
	RESOURCE_UNSUPPORTED_TYPE = "RESOURCE_UNSUPPORTED_TYPE",
	ENDPOINT_INVALID_JSON_SCHEMA = "ENDPOINT_INVALID_JSON_SCHEMA",
	ENDPOINT_INVALID_PATH = "ENDPOINT_INVALID_PATH",
	ENDPOINT_INVALID_MEDIA_TYPE = "ENDPOINT_INVALID_MEDIA_TYPE"
}
